<template>
  <article class="search-show" id="search_show">
    <div class="client-header">
      <div class="client-text-header">
        <h1 v-if="this.loading" class="mb-x2-xs">
          {{ $t("consultaRealizada.titulo") }}
        </h1>
        <h1 v-if="!this.loading && this.isEmpresa" class="mb-x2-xs">
          {{ $t("consultaRealizada.tituloEmpresa") }}
        </h1>
        <h1 v-if="!this.loading && !this.isEmpresa" class="mb-x2-xs">
          {{ $t("consultaRealizada.tituloParticulares") }}
        </h1>
      </div>
      <div class="header-form">
        <div class="completed">
          <img src="@/assets/consultaRealizada/buscador_4.png" />
          <p
            v-if="
              !this.loading && !this.isEmpresa && this.idLegalDeudorSolicitud
            "
          >
            {{ $t("consultaRealizada.textos.informeCompleto_1_particulares") }}
          </p>
          <h6
            v-if="
              !this.loading && !this.isEmpresa && this.idLegalDeudorSolicitud
            "
          >
            {{ $t("consultaRealizada.textos.informeCompleto_2_particulares") }}
            {{ this.idLegalDeudorSolicitud }}
          </h6>

          <h6
            v-if="
              !this.loading && this.isEmpresa && this.idLegalDeudorSolicitud
            "
          >
            {{ $t("consultaRealizada.textos.informaCompleto_1_empresas") }}
            {{ this.idLegalDeudorSolicitud }}
          </h6>
          <p
            v-if="
              !this.loading &&
              this.isEmpresa &&
              this.idLegalDeudorSolicitud &&
              this.informeListoDescarga
            "
          >
            {{ $t("consultaRealizada.textos.informaCompleto_2_empresas") }}
          </p>

          <div
            class="row"
            v-if="!this.loading && this.isEmpresa && this.informeListoDescarga"
          >
            <Button
              @click="descargaDocumento()"
              :label="$t('consultaRealizada.button.descargarInforme')"
              class="bigBlueButton"
              icon="pi pi-arrow-circle-down icono-flecha"
              iconPos="left"
            />
          </div>
          <div
            class="row error_download_text"
            v-if="!this.loading && this.isEmpresa && !this.informeListoDescarga"
          >
            <span class="halve-space-left">{{
              $t("consultaRealizada.textos.generarInforme")
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="p-grid">
      <div class="col-offset-3 p-col-3">
        <div class="container-white-boxed">
          <div class="row">
            <i class="pi pi-info-circle icono-warning"></i>
          </div>
          <div class="row text-center">
            <img src="@/assets/consultaRealizada/buscador_3.png" />
          </div>
          <div class="row">
            <p>
              <span class="span-custom">{{
                $t("consultaRealizada.textos.redescargaInforme_1")
              }}</span>
              {{ $t("consultaRealizada.textos.redescargaInforme_2") }}
            </p>
            <div class="text-center">
              <a
                class="search-btn"
                id="my_claims"
                href="/dashboard/my-searches"
                >{{ $t("consultaRealizada.button.irAMisBusquedas") }}</a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="p-col-3">
        <div class="container-white-boxed">
          <div class="row">
            <i class="pi pi-info-circle icono-warning"></i>
          </div>
          <div class="row text-center">
            <img src="@/assets/consultaRealizada/buscador_5.png" />
          </div>
          <div class="row">
            <p>
              <span class="span-custom">{{
                $t("consultaRealizada.textos.hacerOtraBusqueda_1")
              }}</span>
              {{ $t("consultaRealizada.textos.hacerOtraBusqueda_2") }}
            </p>
            <div class="text-center">
              <a
                class="search-btn"
                id="another_search"
                href="/dashboard/search-debt"
                >{{ $t("consultaRealizada.button.hacerOtraBusqueda") }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { GET_LIST_FILES_BY_TYPE_CLAVE_FILENAME } from "@/graphQLQueries/DocStoreQueries";
import { GET_SOLICITUD_BY_TOKEN } from "@/graphQLQueries/ConsultasQueries.js";
import DownloadsMixin from "@/utils/downloads";
import { TIPOS_FICHEROS } from "@/resources/constants";
import validations from "@/utils/validations.js";
export default {
  name: "ConsultaRealizada",
  mixins: [DownloadsMixin],
  data() {
    return {
      typeFileFM: TIPOS_FICHEROS.FICH_MOROSIDAD_PDF,
      informeListoDescarga: false,
      documentoMinio: undefined,
      interval: undefined,
      tokenSolicitud: undefined,
      estadoSolicitud: undefined,
      idLegalDeudorSolicitud: undefined,
      isEmpresa: undefined,
      loading: true,
      solicitud: {
        token: undefined,
        estado: undefined,
        idLegalDeudor: "",
      },
    };
  },
  mounted() {
    this.tokenSolicitud = this.$route.params.tokenSolicitud
      ? this.$route.params.tokenSolicitud
      : undefined;
    if (this.tokenSolicitud) {
      this.obtenerSolicitud();
    }
  },
  methods: {
    comprobacionFichero() {
      this.$apollo
        .query({
          query: GET_LIST_FILES_BY_TYPE_CLAVE_FILENAME,
          variables: {
            type: this.typeFileFM,
            clave: this.tokenSolicitud,
            filename: this.tokenSolicitud + "_busquedas.pdf",
          },
          fetchPolicy: "no-cache",
        })
        .then((data) => {
          if (data.data.getFileByTypeAndClaveAndFilename) {
            let documentoMinioResponse =
              data.data.getFileByTypeAndClaveAndFilename;
            if (
              documentoMinioResponse != null &&
              documentoMinioResponse != undefined
            ) {
              this.documentoMinio = documentoMinioResponse;
              this.informeListoDescarga = true;
              if (this.interval) clearInterval(this.interval);
            }
          }
        })
        .catch(() => {});
    },
    obtenerSolicitud() {
      this.$apollo
        .query({
          query: GET_SOLICITUD_BY_TOKEN,
          variables: {
            token: this.tokenSolicitud,
          },
          fetchPolicy: "no-cache",
        })
        .then((data) => {
          if (data.data.getSolicitudByToken) {
            this.estadoSolicitud = data.data.getSolicitudByToken.estado;
            this.idLegalDeudorSolicitud =
              data.data.getSolicitudByToken.idLegalDeudor;
            this.checkEsEmpresa();
            if (this.estadoSolicitud && this.estadoSolicitud == "PENDIENTE") {
              this.interval = setInterval(this.comprobacionFichero, 10000);
            } else if (
              this.estadoSolicitud &&
              this.estadoSolicitud == "ACEPTADA"
            ) {
              this.comprobacionFichero();
            }
            this.loading = false;
          }
        })
        .catch(() => {});
    },
    descargaDocumento() {
      this.download(
        this.documentoMinio.filename,
        this.documentoMinio.base64,
        document
      );
    },
    checkEsEmpresa() {
      if (this.idLegalDeudorSolicitud)
        this.isEmpresa = validations.validateNifOrCif(
          this.idLegalDeudorSolicitud.toUpperCase()
        );
      else this.isEmpresa = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>